import React, {useState, useEffect, useRef} from 'react'
import { connect } from 'react-redux'
import {Link, useLocation, withRouter} from 'react-router-dom'
import { Menu, Layout } from 'antd'
import classNames from 'classnames'
import store from 'store'
import PerfectScrollbar from 'react-perfect-scrollbar'
import { find } from 'lodash'
import { FormattedMessage } from 'react-intl'
import { PLATFORM_NAME } from 'config/global'
import qs from 'qs'
import { useUserPermissions } from 'core/permissions/useUserPermissions'
import style from './style.module.scss'
import { menuItemlite, menuItemsOnlyCandidates } from '../../../../../config/menus'
import {isEmpty} from "../../../../platform/utils";
import useSettings from "../../../../platform/hooks/useSettings";

const mapStateToProps = ({ menu, settings, user }) => ({
  menuData: menu.menuData,
  menuDataLite: menuItemlite(user),
  menuOnlyCandidates: menuItemsOnlyCandidates,
  isMenuCollapsed: settings.isMenuCollapsed,
  isMobileView: settings.isMobileView,
  isMenuUnfixed: settings.isMenuUnfixed,
  isMenuShadow: settings.isMenuShadow,
  leftMenuWidth: settings.leftMenuWidth,
  menuColor: settings.menuColor,
  logo: settings.logo,
  tenantLogo: user?.tenant?.logo,
  user
})

const MenuLeft = (props) => {
  const {
    dispatch,
    menuData: menuDataOriginal = [],
    menuDataLite = [],
    menuOnlyCandidates = [],
    location: { pathname },
    isMenuCollapsed,
    isMobileView,
    isMenuUnfixed,
    isMenuShadow,
    leftMenuWidth,
    menuColor,
    tenantLogo,
    user
  } = props
  const [selectedKeys, setSelectedKeys] = useState(store.get('app.menu.selectedKeys') || [])
  const [openedKeys, setOpenedKeys] = useState(store.get('app.menu.openedKeys') || [])

  const permissionsManager = useUserPermissions();

  const location = useLocation();
  const settings = useSettings();
  const query = qs.parse(location.search, { ignoreQueryPrefix: true })
  const oldPlatformRef = useRef(query?.legacy > 0)

  const menuData = oldPlatformRef.current ? menuDataLite : menuDataOriginal

  const finalMenuData = user.onlyCandidates ? menuOnlyCandidates : menuData

  const filterByTenant = (items) => {
    const tenantId = user?.tenant?.id
    if (!tenantId) {
      return items
    }
    return (items || [])
      .filter((item) => {
        if (!item?.tenantIds) {
          return true
        }
        return Array.isArray(item.tenantIds) && item.tenantIds.includes(tenantId)
      })
      .map((item) => {
        if (Array.isArray(item.children)) {
          return { ...item, children: filterByTenant(item.children) }
        }
        return item
      })
  }

  const tenantFilteredMenuData = filterByTenant(finalMenuData)

  const applySelectedKeys = () => {
    const flattenItems = (items, key) =>
      items.reduce((flattenedItems, item) => {
        flattenedItems.push(item)
        if (Array.isArray(item[key])) {
          return flattenedItems.concat(flattenItems(item[key], key))
        }
        return flattenedItems
      }, [])
    const selectedItem = find(flattenItems(menuData, 'children'), ['url', pathname])
    setSelectedKeys(selectedItem ? [selectedItem.key] : [])
  }

  useEffect(() => {
    applySelectedKeys()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname, menuData])



  const onCollapse = (value, type) => {
    if (type === 'responsive' && isMenuCollapsed) {
      return
    }
    dispatch({
      type: 'settings/CHANGE_SETTING',
      payload: {
        setting: 'isMenuCollapsed',
        value: !isMenuCollapsed,
      },
    })
    setOpenedKeys([])
  }

  const onOpenChange = keys => {
    store.set('app.menu.openedKeys', keys)
    setOpenedKeys(keys)
  }

  const handleClick = e => {
    store.set('app.menu.selectedKeys', [e.key])
    setSelectedKeys([e.key])
  }

  const generateMenuItems = () => {
    const generateItem = item => {
      const { key, url, icon: IconProp, disabled, count, onClick } = item

      if (item.settingsDependency !== undefined && !settings[item.settingsDependency]) {
        return null
      }

      let icon = null
      if (IconProp) {
        icon =
          typeof IconProp === 'string' ? (
            <span className={`${IconProp} ${style.icon} icon-collapsed-hidden`} />
          ) : (
            <IconProp className={`${style.icon} icon-collapsed-hidden`} />
          )
      }

      let title = <FormattedMessage id={item.title} />

      if(key === "customers" && settings.useDipartimenti > 0){
        title =  <FormattedMessage id={'customer.departments'} />
      }

      if (item.category) {
        return <Menu.ItemGroup key={Math.random()} title={title} />
      }

      if (item.url) {
        return (
          <Menu.Item key={key} disabled={disabled}>
            {item.target && (
              <a href={url} target={item.target} rel="noopener noreferrer">
                {IconProp && icon}
                <div className={style.title}>{title}</div>
                {count && <span className="badge badge-success ml-2">{count}</span>}
              </a>
            )}
            {!item.target && (
              <Link to={url}>
                {IconProp && icon}
                <div className={style.title}>{title}</div>
                {count && <span className="badge badge-success ml-2">{count}</span>}
              </Link>
            )}
          </Menu.Item>
        )
      }
      return (
        <Menu.Item onClick={onClick} key={key} disabled={disabled}>
          {icon}
          <span className={style.title}>{title}</span>
          {count && <span className="badge badge-success ml-2">{count}</span>}
        </Menu.Item>
      )
    }

    const generateSubmenu = items =>
      items.map(menuItem => {
        if (menuItem.children) {
          const subMenuTitle = (
            <span key={menuItem.key}>
              <span className={style.title}>{menuItem.title}</span>
              {menuItem.count && <span className="badge badge-success ml-2">{menuItem.count}</span>}
            </span>
          )
          return (
            <Menu.SubMenu title={subMenuTitle} key={menuItem.key}>
              {generateSubmenu(menuItem.children)}
            </Menu.SubMenu>
          )
        }
        return generateItem(menuItem)
      })

    return tenantFilteredMenuData.map(menuItem => {

      if (menuItem.settingsDependency !== undefined && !settings[menuItem.settingsDependency]) {
        return null
      }

      const menuPermission = menuItem.permission || `${menuItem.key}:read`;
      if (menuPermission && !permissionsManager.has(menuPermission)){
        return null
      }

      // todo: performance issue https://performa.atlassian.net/browse/PER-1868
      /* if (menuItem.roles && !menuItem.roles.some(r => role.includes(r))) {
        return null
      } */
      const IconProp = menuItem.icon
      const itemIcon =
        typeof IconProp === 'string' ? (
          <span className={`${IconProp} ${style.icon} icon-collapsed-hidden`} />
        ) : (
          <IconProp className={`${style.icon}`} />
        )
      if (menuItem.children) {
        const subMenuTitle = (
          <span key={menuItem.key}>
            {menuItem.icon && itemIcon}
            <div className={style.title}>
              <FormattedMessage id={menuItem.title} />
            </div>
            {menuItem.count && <span className="badge badge-success ml-2">{menuItem.count}</span>}
          </span>
        )
        return (
          <Menu.SubMenu title={subMenuTitle} key={menuItem.key}>
            {generateSubmenu(menuItem.children)}
          </Menu.SubMenu>
        )
      }
      return generateItem(menuItem)
    })
  }

  const menuSettings = isMobileView
    ? {
        width: leftMenuWidth,
        collapsible: false,
        collapsed: false,
        onCollapse,
      }
    : {
        width: leftMenuWidth,
        collapsible: false,
        collapsed: isMenuCollapsed,
        onCollapse,
        breakpoint: 'lg',
      }

  return (
    <Layout.Sider
      {...menuSettings}
      collapsedWidth={64}
      className={classNames(`${style.menu}`, {
        [style.white]: menuColor === 'white',
        [style.gray]: menuColor === 'gray',
        [style.dark]: menuColor === 'dark',
        [style.unfixed]: isMenuUnfixed,
        [style.shadow]: isMenuShadow,
      })}
    >
      <div
        className={style.menuOuter}
        style={{
          width: isMenuCollapsed && !isMobileView ? 64 : leftMenuWidth,
          height: isMobileView || isMenuUnfixed ? 'calc(100% - 64px)' : 'calc(100% - 110px)',
        }}
      >
        <div className={style.logoContainer}>
          <div className={style.logo}>
            {isMenuCollapsed ? (
              <img
                src={'resources/images/logomini.png'}
                style={{ width: '100%', display: 'none' }}
                alt={PLATFORM_NAME}
              />
            ) : (
              <img
                src={isEmpty(tenantLogo) ?  'resources/images/logo_performa_recruit.png' : tenantLogo}
                style={{ width: 212 }}
                alt={PLATFORM_NAME}
              />
            )}
          </div>
        </div>
        <PerfectScrollbar>
          <Menu
            onClick={handleClick}
            selectedKeys={selectedKeys}
            openKeys={openedKeys}
            onOpenChange={onOpenChange}
            mode="inline"
            className={style.navigation}
            inlineIndent="24"
          >
            {generateMenuItems()}
          </Menu>
        </PerfectScrollbar>
        {!isEmpty(tenantLogo) &&
          <div className={style.logoContainer}>
            <div className={style.logo} style={{justifyContent: 'flex-start'}}>
              {!isMenuCollapsed && (
                <div>
                  <div className={style.logoText}>Powered by:</div>
                  <img
                    src={'resources/images/logo_performa_recruit.png'}
                    style={{ width: 130 }}
                    alt={PLATFORM_NAME}
                  />
                </div>
              )}
            </div>
          </div>
        }
      </div>
    </Layout.Sider>
  )
}

export default withRouter(connect(mapStateToProps)(MenuLeft))
